import { signal } from "@preact/signals-react"

export const digitalShelfEvolutionFilters = signal({})
export const digitalShelfEvolutionChartCurrentPeriod = signal("")

export const digitalShelfSubmittedFilters = signal({})
export const digitalShelfReportFormIsOpen = signal(false)